module.exports = __webpack_public_path__ + "media/images/backgrounds/phone-order-450cd36bad7585395d3754a8c6b67ae7288a7f104008f0d2a443df6c0889b7ee.jpg";